<template>
    <base-modal ref="baseModal" @resetform="resetForm()" :load-data="loadData" :send="send" :valid-form="isValid">
        <template v-slot:header>
            <h3>{{$t('sendFax_title')}}</h3>
        </template>

        <div class="form-group">
            <label>{{$t('name_title')}}:</label>
            <input required class="form-control" v-model="title" />
        </div>

        <div class="form-group">
            <label>* {{$t('destination_title')}}:</label>
            <input required class="form-control" v-model="number" />
        </div>

        <div class="form-group">
            <label>{{$t('email_title')}}:</label>
            {{$t('email_info')}}
            <input required class="form-control" v-model="email" />
        </div>
<!--
        <div class="form-group">
            <label>Mail box:</label>
            <input required class="form-control" v-model="mailbox" />
        </div>   -->

        <div class="form-group">
            <label>* {{$t('add_file_title')}}:  (.pdf {{$t('only_text')}})</label>
            <input type="file" @change="input" multiple accept="application/pdf">
        </div>
    </base-modal>

</template>

<script>
import BaseModal from "./BaseModal";
import {AgentService} from "../services/agent-service";
import "../vee-validate";

export default {
	props: {agentService: AgentService},
	data: () => ({
		number: "",
		file: null,
		cover: "",
		title: "",
		email: "",
		mailbox: "",
		snumber: "",
		formatFile: ""
	}),
	components: {BaseModal},
	computed: {
		isValid() {
			return this.number !== "" && this.file !== null;
		}
	},
	methods: {
		async open() {
			this.$refs.baseModal.open();
		},
		resetForm() {
			this.number = "";
			this.file = null;
			this.cover = "";
			this.title = "";
			this.email = "";
			this.mailbox = "";
			this.snumber = "";
		},
		async loadData() {
			// console.log("get data local storeg: ",this.LSM.getFaxDefault())
			this.title = window.LSM.getFaxDefault().name;
			this.email = window.LSM.getFaxDefault().email;
		},
		send() {
			if (!this.isValidInput()) {
				// this.resetForm()  //do we need to add this?
				return Promise.resolve(": " + this.$t("error_file_or_number") + " ."); // do we need to add an explanation about the correct input?
			}
			return this.sendFax();
		},
		sendFax() {
			let data = {
				cnumber: this.number,
				data: this.file,
				cover: this.cover,
				header: this.title,
				email: this.email,
				mailbox: this.mailbox,
				snumber: this.snumber
			};
			console.log(data);
			window.LSM.setFaxDefaults({name: data.header, email: data.email});
			// console.info("update local storage", {name: data.header, email: data.email})
			return this.agentService.sendFax(data).then(res => res === "ok" ? "ok" : false);
		},
		input(event) {
			const data = event.target.files[0];
			const reader = new FileReader();
			reader.readAsDataURL(data);
			reader.onload = () => {
				const base64 = reader.result;
				const startFile = base64.split(",")[0];
				if (startFile.indexOf("pdf") !== -1) {
					this.formatFile = "pdf";
				}
				this.file = base64.substr(base64.indexOf("base64,") + 7);
			};
			reader.onerror = (_error) => {
				this.$refs.baseModal.isError = true;
			};
		},
		isValidInput() {
			if (this.formatFile !== "pdf") {
				console.log("error - invalid file type");
				return false;
			}
			const length = this.number.length;
			const startNumber3 = this.number.substring(0, 3);
			const startNumber2 = this.number.substring(0, 2);
			console.log("length-" + length + " , " + startNumber2 + " , " + startNumber3);
			if (!((startNumber3 === "153" && (length === 11 || length === 12))
             || (length === 10 && ["18", "07"].includes(startNumber2))
             || (length === 9 && ["02", "04", "08", "09", "03"].includes(startNumber2)))) {
				console.log("error - invalid number");
				return false;
			}
			return true;
		}
	}
};

</script>
